import type { ReactNode } from 'react';
import { CookieBanner } from 'shared/src/CookieBanner';

import { initializeTracking } from 'utils/tracking';

type Props = {
  children: ReactNode;
};

export const AuthenticationContainer = ({ children }: Props) => {
  return (
    <div className="flex h-auto min-h-screen w-full flex-col bg-white md:w-144">
      <div className="my-28 flex grow flex-col items-center justify-center">
        {children}
      </div>
      <div className="fixed bottom-4 right-0 flex w-full justify-center lg:bottom-8 lg:right-8 lg:w-1/2">
        <CookieBanner showRejection onAcceptCookies={initializeTracking} />
      </div>
    </div>
  );
};
